import { AxiosError, AxiosResponse } from 'axios';
import { logger } from 'shared/lib';

export const responseInterceptor = (response: AxiosResponse) => response;

export const responseErrorInterceptor = (error: AxiosError) => {
  const logData = {
    message: error?.message ?? 'Unknown error',
    status: error.response?.status ?? 'Unknown status',
    url: error.config?.url,
    method: error.config?.method,
  };
  logger('Interceptor Response Error:', logData, 'error');
  return Promise.reject(error);
};
